const CHALLENGE_URL = process.env.API_URL + '/xugarhero/challenge';
const TEMPLATE_URL = process.env.API_URL + '/xugarhero/challenge/template';

const getPastChallenges = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CHALLENGE_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getActiveChallenges = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CHALLENGE_URL + '/active')
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getChallengeParticipants = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CHALLENGE_URL + '/' + id + '/participants')
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getTemplateChallenges = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(TEMPLATE_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const createTemplate = (context, body) => {
  return new Promise((resolve, reject) => {
    context.$http.post(TEMPLATE_URL, body)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const deleteTemplate = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(TEMPLATE_URL + '/' + id)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

const createChallenge = (context, body) => {
  return new Promise((resolve, reject) => {
    context.$http.post(CHALLENGE_URL, body)
      .then((response) => {
        resolve(response);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getActiveChallenges,
  getTemplateChallenges,
  createTemplate,
  deleteTemplate,
  createChallenge,
  getChallengeParticipants,
  getPastChallenges
};



// WEBPACK FOOTER //
// ./src/brand/health/api/challenge/index.js